export const MIN_INTERNATIONAL_PHONE_LENGTH = 5;
export const MAX_INTERNATIONAL_PHONE_LENGTH = 15;

export const PHONE_CONFIG = {
  "+91": {
    countryName: "India",
    minLength: 10,
    maxLength: 10,
    pattern: "[6-9]\\d{9}",
    formatHint: "10 digits starting with 6-9",
  },
  "+1": {
    countryName: "United States",
    minLength: 10,
    maxLength: 10,
    pattern: "[2-9]\\d{9}",
    formatHint: "10 digits",
  },
  "+971": {
    countryName: "United Arab Emirates",
    minLength: 9,
    maxLength: 9,
    pattern: "5\\d{8}",
    formatHint: "9 digits starting with 5",
  },
  "+966": {
    countryName: "Saudi Arabia",
    minLength: 9,
    maxLength: 9,
    pattern: "5\\d{8}",
    formatHint: "9 digits starting with 5",
  },
  "+974": {
    countryName: "Qatar",
    minLength: 8,
    maxLength: 8,
    pattern: "[3567]\\d{7}",
    formatHint: "8 digits starting with 3, 5, 6, or 7",
  },
  "+968": {
    countryName: "Oman",
    minLength: 8,
    maxLength: 8,
    pattern: "[79]\\d{7}",
    formatHint: "8 digits starting with 7 or 9",
  },
  "+965": {
    countryName: "Kuwait",
    minLength: 8,
    maxLength: 8,
    pattern: "[569]\\d{7}",
    formatHint: "8 digits starting with 5, 6, or 9",
  },
  "+973": {
    countryName: "Bahrain",
    minLength: 8,
    maxLength: 8,
    pattern: "[36]\\d{7}",
    formatHint: "8 digits starting with 3 or 6",
  },
};

export const getPhoneConfigForIsd = (isdCode) =>
  PHONE_CONFIG[isdCode] || {
    minLength: MIN_INTERNATIONAL_PHONE_LENGTH,
    maxLength: MAX_INTERNATIONAL_PHONE_LENGTH,
    pattern: "\\d+",
  };
